import { RESET } from '../redux/game'

// Actions
const HELP_CHANGE_PAGE = 'ascension/help/changepage'
const HELP_SET_TOTAL_PAGES = 'ascension/help/settotalpages'

// Reducer
const initialState = {
  currentPage: 0,
  totalPages: 0
}

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case HELP_CHANGE_PAGE: {
      return {
        ...state,
        currentPage: action.data
      }
    }
    case HELP_SET_TOTAL_PAGES: {
      return {
        ...state,
        totalPages: action.data
      }
    }
    case RESET: {
      return initialState
    }
    default: return state
  }
}

export default reducer

export function updatePage (page) {
  return {
    type: HELP_CHANGE_PAGE,
    data: page
  }
}

export function setTotalPages (total) {
  return {
    type: HELP_SET_TOTAL_PAGES,
    data: total
  }
}
